import React, { FC, useCallback, useMemo } from 'react'

import { alpha, IconButton, Theme, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { isEqual } from 'lodash'
import { useTranslation } from 'react-i18next'

// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import iconCloseWhite from '../../assets/icons/iconCloseWhite.svg'
import iconContactWhite from '../../assets/icons/iconContactWhite.svg'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { useThemeMode } from '../../theme/ThemeModeContext'

import { toggleContactUsModal } from './ContactUsModalSlice'
import { ContactUsButtonProps, ModalLocation } from './types'

export const ContactUsButtonComponent: FC<ContactUsButtonProps> = ({
  position,
  small,
  fullWidth,
  sx,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const { isOpen } = useAppSelector(({ contactUsModal }) => contactUsModal)
  const dispatch = useAppDispatch()

  const { resolvedMode } = useThemeMode()

  // const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY || ''

  const handleToggleModal = useCallback(() => {
    dispatch(toggleContactUsModal())
  }, [toggleContactUsModal, dispatch])

  const width = useMemo(() => {
    if (!fullWidth) {
      return small ? theme.spacing(5.5) : theme.spacing(7)
    }
    return theme.spacing(21.5)
  }, [small, fullWidth])

  return (
    <Box
      className="menu-contact"
      sx={{
        position: 'relative',
      }}
    >
      <IconButton
        sx={{
          width,
          height: small ? theme.spacing(5.5) : theme.spacing(7),
          borderRadius: theme.spacing(3.5),
          backgroundColor: (theme: Theme) =>
            resolvedMode === 'light' ? theme.palette.primary.main : theme.palette.primary.dark,

          ...(position
            ? {
                position: 'fixed',
                bottom: theme.spacing(2),
                right: position === ModalLocation.right ? theme.spacing(2) : 'unset',
                left: position === ModalLocation.left ? theme.spacing(2) : 'unset',
                zIndex: 100,
              }
            : {
                position: 'relative',
              }),

          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.8),
          },

          ...sx,
        }}
        onClick={handleToggleModal}
      >
        {isOpen ? (
          <img src={iconCloseWhite} alt="Close" />
        ) : (
          <img
            src={iconContactWhite}
            alt={String(t('layout.accountPopover.contactUs', 'Contact us'))}
          />
        )}
        {fullWidth && (
          <Typography fontWeight={800} color={theme.palette.primary.light} ml={1}>
            {t('layout.accountPopover.contactUs', 'Contact us').toUpperCase()}
          </Typography>
        )}
      </IconButton>
      {/*<GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>*/}

      {/*</GoogleReCaptchaProvider>*/}
    </Box>
  )
}

export const ContactUsButton = React.memo(ContactUsButtonComponent, isEqual)
